import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import amplifyconfig from './aws-config';
import TrazerContainer from './containers/TrazerContainer';
import HashResult from './components/Trazer/HashResult';
import MainContainer from './containers/MainContainer';
import CertificateGenerator from './components/CertificateGenerator';
import Amplify from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub';
import { withTranslation } from 'react-i18next';
const urls = process.env.REACT_APP_GOUZE_FRONT_URL.split(',');
const titles = process.env.REACT_APP_GOUZE_FRONT_TITLES.split(',');
Amplify.configure(amplifyconfig);

// Apply plugin with configuration
Amplify.addPluggable(new AWSIoTProvider({
  aws_pubsub_region: amplifyconfig.aws_pubsub_region,
  aws_pubsub_endpoint: amplifyconfig.aws_pubsub_endpoint
}));

function App () {
  useEffect(() => {
    const favicon = document.getElementById('favicon');
    let faviconURL;

    const hostname = window.location.hostname;
    if (hostname === urls[0] || hostname === urls[1]) {
      faviconURL = '%PUBLIC_URL%/faviconSB.ico';
      document.title = titles[0];
    } else if (hostname === urls[2]) {
      faviconURL = '%PUBLIC_URL%/faviconTS.ico';
      document.title = titles[1];
    } else {
      faviconURL = '%PUBLIC_URL%/faviconSB.ico';
      document.title = titles[0];
    }
    favicon.href = faviconURL;
  }, []);
  return (
    <Router>
      <Switch>
        <Route exact path='/search' component={TrazerContainer} />
        <Route
          exact
          path='/certificate/:chaincode/:key'
          component={CertificateGenerator}
        />
        <Route path='/search/:type/:key' component={HashResult} />
        <Route from='/' component={MainContainer} />
      </Switch>
    </Router>
  );
}

export default withTranslation()(App);
